<template>
  <div>
    <top-bar heading="Rto"></top-bar>
    <loading-spinner :loading="!loaded"></loading-spinner>
    <div class="container-fluid mt-3" v-if="loaded">
      <b-card header="Edit Rto" no-body>
        <b-card-body class="p-3">
          <div class="row">
            <div class="col-6 col-lg-12 mb-3">
              <label class="control-label visible-ie8 visible-ie9" for="name">Name</label>
              <input
                      :class="{'form-control': true, 'is-invalid': errors.has('name')}"
                      v-validate="'required'"
                      data-vv-delay="500"
                      data-vv-as="Name"
                      data-vv-name="name"
                      type="text"
                      placeholder="Name"
                      name="name"
                      id="name"
                      v-model="rto.name"/>
              <div class="invalid-tooltip d-block" v-if="errors.has('name')">{{ errors.first('name') }}</div>
            </div>
            <div class="col-6 col-lg-12 mb-3">
              <label class="control-label visible-ie8 visible-ie9" for="signature">Signature</label>
              <vue-editor
                      v-model="rto.signature"
                      v-validate="'required'"
                      data-vv-delay="500"
                      data-vv-as="Signature"
                      data-vv-name="signature"
              >

              </vue-editor>
              <div class="invalid-tooltip d-block" v-if="errors.has('signature')">{{ errors.first('signature') }}</div>
            </div>
            <div class="col-12 mb-3">
              <label class="control-label visible-ie8 visible-ie9 d-block" for="user_guide">Logo</label>
              <img :src="rto.logo" class="img-fluid" v-if="rto.logo">
            </div>
            <div class="col-12 mb-3">
              <b-form-file v-model="rto.logo" accept="image/*"></b-form-file>
            </div>
          </div>
          <div class="col-12">
            <loading-button :loading="loading" variant="primary" block @submit="submit" :disabled="errors.any()"></loading-button>
          </div>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RtoEdit',
  data () {
    return {
      rto: {},
      loaded: false,
      loading: false
    };
  },
  methods: {
    submit () {
      this.$validator.validateAll().then(res => {
        if (!res) {
          return;
        }
        this.loading = true;

        let formData = new FormData();
        formData.append('_method', 'PUT');
        Object.keys(this.rto).forEach(key => {
          formData.append(key, this.rto[key]);
        });

        this.axios.post('/rtos/' + this.id, formData).then(rsp => {
          this.$swal('Success', 'Rto Updated', 'success');
          this.rto = rsp.data.data;
          this.loading = false;
        }).catch(err => this.$errorOut(err));
      });
    }
  },
  mounted () {
    this.axios.get('/rtos/' + this.id).then(rsp => {
      this.loaded = true;
      this.rto = rsp.data.data;
    });
  },
  metaInfo: {
    title: 'Edit RTO'
  },
  props: ['id']
};
</script>